module.exports = __webpack_public_path__ + "static/media/bg3.b7e74bcd.jpg";